<template>
  <div class="flex-center no-select">
    <div
      class="position-relative flex-center no-overflow"
      :class="[
        { 'p-0 mr-4' : size == 'mini' },
        { 'shadow-type-7 p-3' : size == 'full' },
      ]">
      <div
        v-if="size == 'full'"
        class="position-absolute w-75 h-25 top-0 left-0 right-0 m-auto bg-muted z-plus-1" />
      <div
        v-if="size == 'full'"
        class="position-absolute h-75 w-25 top-0 bottom-0 right-0 m-auto bg-muted z-plus-1" />
      <div
        v-if="size == 'full'"
        class="position-absolute w-75 h-25 bottom-0 left-0 right-0 m-auto bg-muted z-plus-1" />
      <div
        v-if="size == 'full'"
        class="position-absolute h-75 w-25 top-0 left-0 bottom-0 m-auto bg-muted z-plus-1" />
      <img
        v-if="photoIsUploaded"
        :src="photoUrl"
        class="avatar z-plus-2"
        :class="[
          { 'avatar--mini' : size == 'mini' },
          { 'avatar--full' : size == 'full' },
        ]"
        alt="photo">
      <svg-icon
        v-else
        icon="no-avatar"
        class="avatar z-plus-2"
        :class="[
          { 'avatar--mini' : size == 'mini' },
          { 'avatar--full' : size == 'full' },
        ]" />
      <div
        v-if="photoIsUploaded"
        class="lines position-absolute z-plus-3 no-overflow"
        :class="[
          { 'lines--mini top-0 left-0' : size == 'mini' },
          { 'lines--full top-3 left-3' : size == 'full' },
        ]" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    size: {
      type: String,
      required: true,
      default: 'full',
    },
  },
  computed: {
    userUid() {
      return this.$store.state.user.uid
    },

    photoIsUploaded() {
      return this.$store.state.user.photoIsUploaded || false
    },

    photoUrl() {
      if (this.photoIsUploaded) {
        return `${process.env.VUE_APP_QUIZ}/photo/${this.userUid}`
      } else {
        return false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/@core/globals';

.avatar {
  &--mini {
    @include icon-size(46px);
  }

  &--full {
    @include icon-size(140px);
  }
}

.lines {
  &--mini {
    @include icon-size(46px);
  }

  &--full {
    @include icon-size(140px);
  }

  &::before {
    @include linear-gradient('white_transparent');

    @include animation(
      $name: scanner-bar,
      $duration: 3.5s,
      $count: infinite,
      $timing: ease-in-out,
    );

    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 30%;
    top: 0;
    left: 0;
    transform: translateY(-100%);
    border-bottom: 2px solid color('white');
  }
}
</style>
